let config = {
  emailjs: {
    serviceID: "service_ucb5bx6",
    templateID: "template_97o5pcj",
    userID: "FYBBx7oFcInwZv68x"
  }
};

export default config;
